import { GET_LABELS_WITH_KRN_FAILURE, GET_LABELS_WITH_KRN_REQUEST, GET_LABELS_WITH_KRN_SUCCESS, labelsWithKrnInitialState } from "actions/labelsWithKrnActions";

import { DONE, EMPTY, ERROR, IN_PROGRESS } from "constants/Status";

const initialLabelsWithKrnState = { status: EMPTY, ...labelsWithKrnInitialState };

export const labelsWithKrnReducer = (
    state = initialLabelsWithKrnState,
    action: any
): any => {
    const newState = reduceLabelsRequest(state, action);
    return newState;
};

const reduceLabelsRequest = (state: any, action: any): any => {
    switch (action.type) {
        case GET_LABELS_WITH_KRN_SUCCESS:
            return {
                ...state,
                status: DONE,
                labelsWithKrn: action.response,
            };
        case GET_LABELS_WITH_KRN_REQUEST:
            return {
                ...state,
                status: IN_PROGRESS,
            };
        case GET_LABELS_WITH_KRN_FAILURE:
            return {
                status: ERROR,
                error: action.error,
            };
        default:
            return state;
    }
};

export default {
    labelsWithKrnReducer,
};
